"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../stitches.config");

var _LocaleSelect = _interopRequireDefault(require("../locale-select/LocaleSelect"));

var footerDesktopStyles = {
  borderTop: '1px solid $grey300',
  flexDirection: 'row',
  minHeight: 'unset',
  position: 'sticky'
};
var StyledFooter = (0, _stitches.styled)('footer', {
  alignItems: 'center',
  backgroundColor: '$white',
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  minHeight: '55px',
  paddingBottom: '3px',
  paddingTop: '3px',
  width: '100%',
  a: {
    color: '$textBlack'
  },
  select: {
    color: '$textBlack'
  },
  '@desktop': footerDesktopStyles
});
var linksDesktopStyles = {
  flexBasis: '77%',
  justifyContent: 'flex-start',
  marginLeft: '10px',
  a: {
    marginBottom: '0',
    marginTop: '0',
    '&:not(:first-child)': {
      borderLeft: 'none',
      paddingLeft: 'initial'
    }
  }
};
var LinksContainer = (0, _stitches.styled)('div', {
  alignContent: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '5px',
  width: '85%',
  a: {
    marginBottom: '5px',
    marginTop: '5px',
    '&:not(:first-child)': {
      borderLeft: '1px solid $grey400',
      paddingLeft: '5px'
    }
  },
  '@desktop': linksDesktopStyles
});
/**
 * A basic footer that has a link section and a locale select section.
 */

var Footer = function Footer(_ref) {
  var children = _ref.children,
      i18n = _ref.i18n;
  return /*#__PURE__*/_react.default.createElement(StyledFooter, null, /*#__PURE__*/_react.default.createElement(LinksContainer, null, children), /*#__PURE__*/_react.default.createElement(_LocaleSelect.default, {
    i18n: i18n
  }));
};

Footer.defaultProps = {};
var _default = Footer;
exports.default = _default;